import React from "react"
import { CheckboxItem } from "./item"
 
export const Checkboxes = ({data, title}) => {
    return (<div className="checkboxlist" >
        <h4>{title || ''}</h4>
        <ul>
            {
                data && data.length > 0 && data.map((item,i)=>{
                    return (
                        <CheckboxItem item={item} index={i} />
                    )
                })
            }
        </ul>
    </div>)

}
